export const UPLOAD_USER_FILE_RESPONSE = 'UPLOAD_USER_FILE_RESPONSE';
export const SET_SELECTED_USERS_FOR_PRINT = 'SET_SELECTED_USERS_FOR_PRINT';
export const SET_SIDEBAR_ITEM_KEY = 'SET_SIDEBAR_ITEM_KEY';
export const EXPORT_FILE_RESPONSE = 'EXPORT_FILE_RESPONSE';
export const FILE_UPLOAD_HISTORY_RESPONSE = 'FILE_UPLOAD_HISTORY_RESPONSE';
export const DOWNLOAD_PDF_RESPONSE = 'DOWNLOAD_PDF_RESPONSE';
export const USER_LIST_RESPONSE = 'USER_LIST_RESPONSE';
export const LIST_NOTIFICATION_PREFERENCE_RESPONSE = 'LIST_NOTIFICATION_PREFERENCE_RESPONSE';
export const SEND_NOTIFICATIONS = 'SEND_NOTIFICATIONS';
export const FILTERED_NOTIFICATION_RESPONSE = 'FILTERED_NOTIFICATION_RESPONSE';